import { interopDefault } from '~/utils';
import RouteEnum from '~/enums/RouteEnum';

export default [
  {
    path: '/applicants',
    name: RouteEnum.APPLICANTS.INDEX,
    component: () =>
      interopDefault(
        import(
          /* webpackChunkName: 'employee:applicants.index' */ '~/pages/employee/applicants/index.vue'
        )
      ),
  },
];
